import PropTypes from 'prop-types'
import React from 'react'
import ImmutablePropTypes from 'react-immutable-proptypes'
import _omit from 'lodash/omit'
import _get from 'lodash/get'
import { Map, List } from 'immutable'
import { connect as connectRedux } from 'react-redux'
import { compose } from 'recompose'
import { get as getConfig } from '../../config/index'
import Filter from '../Filter/index'
import { connect as connectStaticText } from '../StaticText/connect'
import HistoryContext from '../Router/HistoryContext'
import { historyRedirect } from '../../services/navigation/index'
import { getBoundActions } from '../../actions/index'
import {
  PRIMARY_LANGUAGE_CHANGED_GA4_EVENT,
} from '../../services/event-tracking/index'

const config = getConfig()

function createDefaultOption (langs, languagePreference) {
  return langs.find((v) => v.get('value') === languagePreference)
}

class LanguageQuickSelect extends React.Component {
  //
  onChange = (target) => {
    const { props, context: history } = this
    const {
      auth,
      location,
      setFeatureTrackingDataPersistent,
      setEventDefault,
    } = props
    const { value: language } = target

    setFeatureTrackingDataPersistent({
      data: Map({ userLanguages: List([language]) }),
      auth,
    })

    // GA4 events
    const eventData = PRIMARY_LANGUAGE_CHANGED_GA4_EVENT
      .mergeDeep({
        changed_to: language,
        ui_element: 'Footer',
      })
    setEventDefault(eventData)

    // This sets assumes that there is no secondary language support
    if (!auth.get('jwt')) {
      // For anonymous users just change the URL
      historyRedirect({
        query: _omit(location.query, ['language']),
        url: location.pathname,
        language,
        history,
        auth,
      })
    }
  }

  render () {
    const { props } = this
    const { languages, languagePreference, staticText } = props
    const label = String(staticText.getIn([
      'data',
      'myLanguage',
    ]) || '')

    const allowSelectFr = !!_get(config, 'features.languageSelectFr')
    const allowSelectDe = !!_get(config, 'features.languageSelectDe')
    const langs = languages.get('data', List()).filter((lang) => ((allowSelectFr && lang.get('name') === 'Français')
        || (allowSelectDe && lang.get('name') === 'Deutsch')
        || ['Français', 'Deutsch'].indexOf(lang.get('name')) < 0))
    return (
      <div className="language-quick-select">
        <Filter
          options={langs}
          formInputName="filter-language-quick-select"
          label={label}
          onChange={this.onChange}
          className={['language-quick-select__control']}
          labelClassName={['language-quick-select__label']}
          defaultOption={createDefaultOption(langs, languagePreference)}
        />
      </div>
    )
  }
}

LanguageQuickSelect.propTypes = {
  languages: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  auth: ImmutablePropTypes.map.isRequired,
  getLanguagesData: PropTypes.func.isRequired,
  staticText: ImmutablePropTypes.map.isRequired,
  setFeatureTrackingDataPersistent: PropTypes.func.isRequired,
  setEventDefault: PropTypes.func,
}

LanguageQuickSelect.contextType = HistoryContext

export default compose(
  connectStaticText({ storeKey: 'languageSelect' }),
  connectRedux(
    (state) => ({
      languagePreference: state.user.getIn(['data', 'language', 0], 'en'),
      location: state.resolver.get('location'),
      languages: state.languages,
      auth: state.auth,
    }),
    (dispatch) => {
      const actions = getBoundActions(dispatch)
      return {
        setFeatureTrackingDataPersistent:
          actions.featureTracking.setFeatureTrackingDataPersistent,
        getLanguagesData: actions.languages.getLanguagesData,
        setEventDefault: actions.eventTracking.setEventDefault,
      }
    },
  ),
)(LanguageQuickSelect)
